<template>
  <div class="navbar has-background-white-bis">
    <div class="navbar-start">
      <div class="navbar-item">
        <div>
          <a @click="$router.go(-1)">
            <span>Locations</span>
          </a> / Location: <strong>{{ locationName }}</strong>
        </div>
      </div>
    </div>
    <div class="navbar-end">
      <div class="navbar-item">
        <LocationEditRight />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex/dist/vuex.common'
import LocationEditRight from './LocationEditRight.vue';
export default {
  components: {
    LocationEditRight
  },

  data() {
    return {}
  },

  computed: {
    ...mapGetters('locationStore', ['locationName'])
  }
}
</script>

<style lang="scss" scoped>
</style>